import * as React from 'react';

import { MAX_CHAR_LIMIT } from '@src/config/constants';
import { useSurvey } from '@src/hooks/useSurvey';
import { SurveyQuestionProps } from './SurveyQuestion';

export interface TypeTextareaProps extends SurveyQuestionProps {}

/**
 * @name TypeTextarea
 * @description Collect some text information from the survey
 */
export const TypeTextarea = (props: TypeTextareaProps) => {
  const { question } = props;

  // Hooks
  const { answers, setAnswer } = useSurvey();
  const value = answers[question.name];
  const length = typeof value === 'string' ? value.length : 0;
  const cssMaxCharLimit = length >= MAX_CHAR_LIMIT ? 'text-red' : 'text-gray-5';

  // Setup
  const { error_message, placeholder, required = false } = question;

  // Handlers
  const onChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    event.currentTarget.setCustomValidity('');

    const value = event.target.value !== '' ? event.target.value : undefined;

    setAnswer(question.name, value);
  };

  return (
    <>
      <textarea
        className="mb-0 min-w-full max-w-full rounded-none border-0 p-3 font-beatrice-light text-14 md:px-8 md:pt-4 md:text-18"
        defaultValue={value}
        name={question.name}
        onChange={onChangeHandler}
        onInvalid={(event: React.FormEvent<HTMLTextAreaElement>) => {
          if (error_message)
            event.currentTarget.setCustomValidity(error_message);
        }}
        placeholder={placeholder ?? ''}
        required={required}
        rows={6}
        maxLength={500}
      />
      <div className={`mt-1 text-right ${cssMaxCharLimit}`}>
        ({length}/{MAX_CHAR_LIMIT})
      </div>
    </>
  );
};
